export default "__VITE_ASSET__3db5e281__"